export const capitalize = (value: string) =>
	`${value.charAt(0).toUpperCase()}${value.slice(1)}`

export const allWordsCapitalize = (value: string) =>
	value
		.split(' ')
		.map((word) => capitalize(word))
		.join(' ')
